import React, { useRef, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom'; // use react-router-dom everywhere
import ActionButtons from '../components/ActionButtons';
import Header from '../components/Header';
import Loader from '../components/Loader';
import { fields, LOCAL_STORAGE_KEY } from '../constants';
import { getDetailsApi } from '../utils/api';
import { mergeLookupDetails } from '../utils/lookupDetails';

const Bihar = () => {
  const isLoggedIn = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || 'null');

  const state = 'bihar';
  const history = useHistory();

  // all input fields
  const [payLoad, setPayLoad] = useState({
    vehicleNo: '',
    chassisNo: '',
    mobileNo: '',
    vehiclePermitType: '',
    seatingCapacityExcludingDriver: '',
    sleeperCapacityExcludingDriver: '',
    borderBarrier: '',
    totalAmount: '',
    ownerName: '',
    fromState: '',
    vehicleClass: '',
    vehicleCategory: '',
    taxMode: '',
    taxFromDate: '',
    taxUptoDate: '',
    paymentMode: '',
    checkpostName: '',
    permitType: '',
    grossVehicleWeight: '',
    unladenWeight: '',
    insuranceValidity: '',
    puccValidity: '',
    fitnessValidity: '',
    permitValidity: '',
    mvTax: '',
    serviceType: '',
  });

  const [isLoading, setIsLoading] = useState(false);

  const form = useRef(null);

  const getDetailsHandler = async () => {
    if (!payLoad.vehicleNo) {
      alert('Please enter vehicle no.');
      return;
    }
    setIsLoading(true);
    const { data } = await getDetailsApi({
      vehicleNo: payLoad.vehicleNo,
    });
    setIsLoading(false);
    if (data && data.success) {
setPayLoad((e) => ({
        ...e,
        ...mergeLookupDetails(e, data.detail),
      }));
    }
  };

  const onSubmitHandler = async (e) => {
    e.preventDefault();
    if (!payLoad.unladenWeight) {
      payLoad.unladenWeight = 0;
    }
    history.push('/select-payment', {
      formData: {
        ...payLoad,
        state,
      },
    });
  };

  const onChangeHandler = (e) => {
    setPayLoad((old) => ({ ...old, [e.target.name]: e.target.value }));
  };

  const onResetHandler = () => {
    let x = { ...payLoad };
    let p = {};
    Object.keys(x).forEach((e) => {
      p[e] = '';
    });
    setPayLoad({ ...p });
  };

  useEffect(() => {
    setPayLoad((prev) => ({
      ...prev,
      totalAmount: prev.mvTax || '',
    }));
  }, [payLoad.mvTax]);

  // Guard isLoggedIn so page doesn't crash if not logged in
  if (!isLoggedIn || !isLoggedIn.accessState || !isLoggedIn.accessState.includes(fields.stateName.bihar)) {
    return (
      <>
        <Header />
        <div className='container text-center mt-4 '>
          <h3>No Access of this state</h3>
        </div>
      </>
    );
  }

  return (
    <>
      <Header />
      <div className='text-center'>
        <p className='login-heading mt-4'>
          <b>TAX PAYMENT FOR VEHICLES HAVING TOURIST PERMIT</b>{' '}
          <span>BIHAR</span>
        </p>
      </div>
      <div className='box box--main'>
        <div className='box__heading--blue'>Tax Payment Details</div>
        <form
          ref={form}
          onSubmit={onSubmitHandler}
          className='service-type tax-details mt-4'
        >
          <div className='row'>
            <div className='col-6'>
              {/* <!-- vehicle number --> */}
              <div className='form__control'>
                <label
                  className='form__label d-block w-100 text-left'
                  htmlFor='vehicleNo'
                >
                  Vehicle No.<sup>*</sup>
                </label>
                <input
                  tabIndex='1'
                  required
                  maxLength='10'
                  autoFocus
                  inputMode='text'
                  disabled={isLoading}
                  value={payLoad.vehicleNo}
                  onChange={onChangeHandler}
                  className='form__input w-100'
                  type='text'
                  id='vehicleNo'
                  name='vehicleNo'
                />
              </div>
              {/* <!-- mobile number (moved up) --> */}
              <div className='form__control'>
                <label
                  className='form__label d-block w-100 text-left'
                  htmlFor='mobileNo'
                >
                  Mobile No.<sup>*</sup>
                </label>
                <input
                  required
                  tabIndex='2'
                  disabled={isLoading}
                  value={payLoad.mobileNo}
                  onChange={onChangeHandler}
                  placeholder='SMS about payment will be sent to this number '
                  className='form__input w-100'
                  type='text'
                  id='mobileNo'
                  inputMode='tel'
                  maxLength='10'
                  minLength='10'
                  name='mobileNo'
                />
              </div>
              {/* <!-- chassis number --> */}
              <div className='form__control'>
                <label
                  className='form__label d-block w-100 text-left'
                  htmlFor='chassisNo'
                >
                  Chassis No.<sup>*</sup>
                </label>
                <input
                  required
                  tabIndex='3'
                  maxLength='19'
                  inputMode='text'
                  disabled={isLoading}
                  onChange={onChangeHandler}
                  value={payLoad.chassisNo}
                  className='form__input w-100'
                  type='text'
                  id='chassisNo'
                  name='chassisNo'
                />
              </div>
              {/* <!-- vehicle type (moved down) --> */}
              <div className='form__control'>
                <label
                  className='form__label d-block w-100 text-left'
                  htmlFor='vehiclePermitType'
                >
                  Vehicle Type<sup>*</sup>
                </label>
                <select
                  tabIndex='4'
                  value={payLoad.vehiclePermitType}
                  onChange={onChangeHandler}
                  required
                  name='vehiclePermitType'
                  id='vehiclePermitType'
                  disabled={isLoading}
                >
                  <option value=''>--Select vehicle type--</option>
                  <option value='TRANSPORT'>TRANSPORT</option>
                  <option value='NON-TRANSPORT'>NON-TRANSPORT</option>
                </select>
              </div>
              
              {['THREE WHEELER (PASSENGER)', 'MOTOR CAB', 'MAXI CAB', 'OMNI BUS', 'BUS'].includes(payLoad.vehicleClass) ? (
                <div className='row'>
                  {/* <!-- seating capacity --> */}
                  <div className='col-sm-6'>
                    <div className='form__control'>
                      <label
                        className='form__label d-block w-100 text-left'
                        htmlFor='seatingCapacityExcludingDriver'
                      >
                        Seating Capacity<sup>*</sup>
                      </label>
                      <input
                        required
                        tabIndex='5'
                        min='0'
                        disabled={isLoading}
                        onChange={onChangeHandler}
                        className='form__input w-100'
                        type='number'
                        value={payLoad.seatingCapacityExcludingDriver}
                        id='seatingCapacityExcludingDriver'
                        name='seatingCapacityExcludingDriver'
                      />
                    </div>
                  </div>

                  {/* <!-- sleeper capacity --> */}
                  <div className='col-sm-6'>
                    <div className='form__control'>
                      <label
                        className='form__label d-block w-100 text-left'
                        htmlFor='sleeperCapacityExcludingDriver'
                      >
                        Sleeper Capacity<sup>*</sup>
                      </label>
                      <input
                        tabIndex='6'
                        required
                        min='0'
                        disabled={isLoading}
                        onChange={onChangeHandler}
                        value={payLoad.sleeperCapacityExcludingDriver}
                        className='form__input w-100'
                        type='number'
                        id='sleeperCapacityExcludingDriver'
                        name='sleeperCapacityExcludingDriver'
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div className='row'>
                  {/* <!-- gross vehicle weight --> */}
                  <div className='col-sm-6'>
                    <div className='form__control'>
                      <label
                        className='form__label d-block w-100 text-left'
                        htmlFor='grossVehicleWeight'
                      >
                        Gross Vehicle Wt.(in kg)<sup>*</sup>
                      </label>
                      <input
                        required
                        tabIndex='5'
                        min='0'
                        disabled={isLoading}
                        onChange={onChangeHandler}
                        className='form__input w-100'
                        type='number'
                        value={payLoad.grossVehicleWeight}
                        id='grossVehicleWeight'
                        name='grossVehicleWeight'
                      />
                    </div>
                  </div>
                  {/* <!-- un laden weight --> */}
                  <div className='col-sm-6'>
                    <div className='form__control'>
                      <label
                        className='form__label d-block w-100 text-left'
                        htmlFor='unladenWeight'
                      >
                        Unladen Wt.(in kg)<sup>*</sup>
                      </label>
                      <input
                        required
                        tabIndex='6'
                        min='0'
                        disabled={isLoading}
                        onChange={onChangeHandler}
                        className='form__input w-100'
                        type='number'
                        value={payLoad.unladenWeight}
                        id='unladenWeight'
                        name='unladenWeight'
                      />
                    </div>
                  </div>
                </div>
              )}
              <div className='form__control'>
                <label className='form__label d-block w-100 text-left' htmlFor='serviceType'>
                  Service Type<sup>*</sup>
                </label>
                <select
                  tabIndex='7'
                  required
                  disabled={isLoading}
                  value={payLoad.serviceType}
                  onChange={onChangeHandler}
                  name='serviceType'
                  id='serviceType'
                >
                  <option value=''>--Select Service Type--</option>
                  <option value='NOT APPLICABLE'>NOT APPLICABLE</option>
                  <option value='ORDINARY'>ORDINARY</option>
                  <option value='AIR CONDITIONED'>AIR CONDITIONED</option>
                </select>
              </div>
              <div className='form__control'>
                <label className='form__label d-block w-100 text-left' htmlFor='taxMode'>
                  Tax Mode<sup>*</sup>
                </label>
                <select
                  tabIndex='9'
                  required
                  disabled={isLoading}
                  onChange={onChangeHandler}
                  value={payLoad.taxMode}
                  name='taxMode'
                  id='taxMode'
                >
                  <option value=''>--Select Tax Mode--</option>
                  {fields.taxMode.map((type) => (
                    <option value={type.name} key={type.name}>
                      {type.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {/* =========================== right side fields ============================ */}
            <div className='col-6'>
              <div className='form__control text-left'>
                <label className='form__label d-block w-100 text-left'>
                  &nbsp;
                </label>
                {isLoading && <Loader className='loader__get-details' />}
                {!isLoading && (
                  <button
                    disabled={isLoading}
                    type='button'
                    onClick={getDetailsHandler}
                    className='box__button get-details'
                  >
                    <span className='glyphicon glyphicon-arrow-down mr-3'></span>
                    Get Details
                  </button>
                )}
              </div>
              {/* <!-- owner name --> */}
              <div className='form__control'>
                <label
                  className='form__label d-block w-100 text-left'
                  htmlFor='ownerName'
                >
                  Owner Name<sup>*</sup>
                </label>
                <input
                  required
                  tabIndex='9'
                  disabled={isLoading}
                  className='form__input w-100'
                  type='text'
                  id='ownerName'
                  inputMode='text'
                  name='ownerName'
                  onChange={onChangeHandler}
                  value={payLoad.ownerName}
                />
              </div>
              {/* <!-- from state --> */}
              <div className='form__control'>
                <label
                  className='form__label d-block w-100 text-left'
                  htmlFor='fromState'
                >
                  From State<sup>*</sup>
                </label>
<select
                  tabIndex='10'
                  disabled={isLoading}
                  required
                  value={payLoad.fromState}
                  onChange={onChangeHandler}
                  name='fromState'
                  id='fromState'
                >
                  <option value=''>--Select State--</option>
                  {fields.fromState.map((type) => {
                    return (
                      <option key={type.name} value={String(type.name).toUpperCase()}>
                        {type.name}
                      </option>
                    );
                  })}
                </select>
              </div>

              <div className='row'>
                <div className='col-sm-6'>
                  <div className='form__control'>
                    <label className='form__label d-block w-100 text-left' htmlFor='vehicleClass'>
                      Vehicle Class<sup>*</sup>
                    </label>
                    <select
                      tabIndex='11'
                      required
                      disabled={isLoading}
                      value={payLoad.vehicleClass}
                      onChange={onChangeHandler}
                      name='vehicleClass'
                      id='vehicleClass'
                    >
                      <option value=''>--Select Vehicle Class--</option>
                      {payLoad.vehiclePermitType === 'TRANSPORT' ? (
                        <>
                          <option value='THREE WHEELER (PASSENGER)'>THREE WHEELER (PASSENGER)</option>
                          <option value='MOTOR CAB'>MOTOR CAB</option>
                          <option value='MAXI CAB'>MAXI CAB</option>
                          <option value='OMNI BUS'>OMNI BUS</option>
                          <option value='BUS'>BUS</option>
                          <option value='GOODS CARRIER'>GOODS CARRIER</option>
                          <option value='THREE WHEELER (GOODS)'>THREE WHEELER (GOODS)</option>
                        </>
                      ) : payLoad.vehiclePermitType === 'NON-TRANSPORT' ? (
                        <>
                          <option value='CONSTRUCTION EQUIPMENT VEHICLE'>CONSTRUCTION EQUIPMENT VEHICLE</option>
                          <option value='CRANE MOUNTED VEHICLE'>CRANE MOUNTED VEHICLE</option>
                        </>
                      ) : (
                        <>
                          <option value='THREE WHEELER (PASSENGER)'>THREE WHEELER (PASSENGER)</option>
                          <option value='MOTOR CAB'>MOTOR CAB</option>
                          <option value='MAXI CAB'>MAXI CAB</option>
                          <option value='OMNI BUS'>OMNI BUS</option>
                          <option value='BUS'>BUS</option>
                          <option value='GOODS CARRIER'>GOODS CARRIER</option>
                          <option value='THREE WHEELER (GOODS)'>THREE WHEELER (GOODS)</option>
                        </>
                      )}
                    </select>
                  </div>
                </div>
                <div className='col-sm-6'>
                  <div className='form__control'>
                    <label className='form__label d-block w-100 text-left' htmlFor='vehicleCategory'>
                      Vehicle Category<sup>*</sup>
                    </label>
                    <select
                      tabIndex='12'
                      required
                      disabled={isLoading}
                      value={payLoad.vehicleCategory}
                      onChange={onChangeHandler}
                      name='vehicleCategory'
                      id='vehicleCategory'
                    >
                      <option value=''>--Select Vehicle Category--</option>
                      {payLoad.vehiclePermitType === 'TRANSPORT' ? (
                        ['GOODS CARRIER'].includes(payLoad.vehicleClass) ? (
                          <>
                            <option value='LIGHT GOODS VEHICLE'>LIGHT GOODS VEHICLE</option>
                            <option value='MEDIUM GOODS VEHICLE'>MEDIUM GOODS VEHICLE</option>
                            <option value='HEAVY GOODS VEHICLE'>HEAVY GOODS VEHICLE</option>
                          </>
                        ) : (
                          <>
                            <option value='LIGHT PASSENGER VEHICLE'>LIGHT PASSENGER VEHICLE</option>
                            <option value='MEDIUM PASSENGER VEHICLE'>MEDIUM PASSENGER VEHICLE</option>
                            <option value='HEAVY PASSENGER VEHICLE'>HEAVY PASSENGER VEHICLE</option>
                          </>
                        )
                      ) : payLoad.vehiclePermitType === 'NON-TRANSPORT' ? (
                        <>
                          <option value='HEAVY GOODS VEHICLE'>HEAVY GOODS VEHICLE</option>
                          <option value='LIGHT GOODS VEHICLE'>LIGHT GOODS VEHICLE</option>
                          <option value='LIGHT PASSENGER VEHICLE'>LIGHT PASSENGER VEHICLE</option>
                          <option value='MEDIUM GOODS VEHICLE'>MEDIUM GOODS VEHICLE</option>
                          <option value='MEDIUM PASSENGER VEHICLE'>MEDIUM PASSENGER VEHICLE</option>
                        </>
                      ) : (
                        ['GOODS CARRIER'].includes(payLoad.vehicleClass) ? (
                          <>
                            <option value='LIGHT GOODS VEHICLE'>LIGHT GOODS VEHICLE</option>
                            <option value='MEDIUM GOODS VEHICLE'>MEDIUM GOODS VEHICLE</option>
                            <option value='HEAVY GOODS VEHICLE'>HEAVY GOODS VEHICLE</option>
                          </>
                        ) : (
                          <>
                            <option value='LIGHT PASSENGER VEHICLE'>LIGHT PASSENGER VEHICLE</option>
                            <option value='MEDIUM PASSENGER VEHICLE'>MEDIUM PASSENGER VEHICLE</option>
                            <option value='HEAVY PASSENGER VEHICLE'>HEAVY PASSENGER VEHICLE</option>
                          </>
                        )
                      )}
                    </select>
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-sm-6'>
                  <div className='form__control'>
                    <label className='form__label d-block w-100 text-left' htmlFor='borderBarrier'>
                      District Name<sup>*</sup>
                    </label>
                    <select
                      tabIndex='14'
                      required
                      disabled={isLoading}
                      value={payLoad.borderBarrier}
                      onChange={(e) => {
                        const v = e.target.value;
                        setPayLoad((old) => ({ ...old, borderBarrier: v, checkpostName: v }));
                      }}
                      name='borderBarrier'
                      id='borderBarrier'
                    >
                      <option value=''>--Select District/Barrier--</option>
                      {fields.bihar.borderBarrier.map((dist) => (
                        <option key={dist.name} value={dist.name}>
                          {dist.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className='col-sm-6'>
                  <div className='form__control'>
                    <label className='form__label d-block w-100 text-left' htmlFor='checkpostName'>
                      Checkpost Name<sup>*</sup>
                    </label>
                    <select
                      tabIndex='15'
                      disabled={isLoading}
                      required
                      value={payLoad.checkpostName}
                      onChange={onChangeHandler}
                      name='checkpostName'
                      id='checkpostName'
                    >
                      <option value=''>--Select CheckPost Name</option>
                      {fields.bihar.borderBarrier.map((dist) => (
                        <option key={dist.name} value={dist.name}>
                          {dist.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-sm-6'>
                  <div className='form__control'>
                    <label className='form__label d-block w-100 text-left' htmlFor='insuranceValidity'>
                      Insurance Validity<sup>*</sup>
                    </label>
                    <input
                      tabIndex='16'
                      required
                      disabled={isLoading}
                      className='form__input w-100'
                      type='date'
                      id='insuranceValidity'
                      name='insuranceValidity'
                      onChange={onChangeHandler}
                      value={payLoad.insuranceValidity}
                    />
                  </div>
                </div>
                <div className='col-sm-6'>
                  <div className='form__control'>
                    <label className='form__label d-block w-100 text-left' htmlFor='puccValidity'>
                      PUCC Validity<sup>*</sup>
                    </label>
                    <input
                      tabIndex='17'
                      required
                      disabled={isLoading}
                      className='form__input w-100'
                      type='date'
                      id='puccValidity'
                      name='puccValidity'
                      onChange={onChangeHandler}
                      value={payLoad.puccValidity}
                    />
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-sm-6'>
                  <div className='form__control'>
                    <label className='form__label d-block w-100 text-left' htmlFor='fitnessValidity'>
                      Fitness Validity<sup>*</sup>
                    </label>
                    <input
                      tabIndex='18'
                      required
                      disabled={isLoading}
                      className='form__input w-100'
                      type='date'
                      id='fitnessValidity'
                      name='fitnessValidity'
                      onChange={onChangeHandler}
                      value={payLoad.fitnessValidity}
                    />
                  </div>
                </div>
                <div className='col-sm-6'>
                  <div className='form__control'>
                    <label className='form__label d-block w-100 text-left' htmlFor='permitValidity'>
                      Road Tax Validity<sup>*</sup>
                    </label>
                    <input
                      tabIndex='19'
                      required
                      disabled={isLoading}
                      className='form__input w-100'
                      type='datetime-local'
                      id='permitValidity'
                      name='permitValidity'
                      onChange={onChangeHandler}
                      value={payLoad.permitValidity}
                    />
                  </div>
                </div>
              </div>
              
            </div>
          </div>
          {/* =============== Tax dates just before table ======================== */}
          <div className='row mt-3'>
            <div className='col-sm-6'>
              <div className='form__control'>
                <label className='form__label d-block w-100 text-left' htmlFor='paymentMode'>
                  Payment Mode<sup>*</sup>
                </label>
                <select
                  tabIndex='10'
                  required
                  disabled={isLoading}
                  value={payLoad.paymentMode}
                  onChange={onChangeHandler}
                  name='paymentMode'
                  id='paymentMode'
                >
                  <option value=''>--Select Payment Mode--</option>
                  {fields.bihar.paymentMode.map((pay) => (
                    <option key={pay.name} value={pay.name}>
                      {pay.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className='form__control'>
                <label className='form__label d-block w-100 text-left' htmlFor='taxFromDate'>
                  Tax From Date<sup>*</sup>
                </label>
                <input
                  required
                  disabled={isLoading}
                  className='form__input w-100'
                  type='datetime-local'
                  id='taxFromDate'
                  name='taxFromDate'
                  onChange={onChangeHandler}
                  value={payLoad.taxFromDate}
                />
              </div>
            </div>
            <div className='col-sm-6'>
              <div className='form__control'>
                <label className='form__label d-block w-100 text-left' htmlFor='permitType'>
                  Permit Type<sup>*</sup>
                </label>
                <select
                  tabIndex='11'
                  required
                  disabled={isLoading}
                  value={payLoad.permitType}
                  onChange={onChangeHandler}
                  name='permitType'
                  id='permitType'
                >
                  <option value=''>--Select Permit Type--</option>
                  <option value='NOT APPLICABLE'>NOT APPLICABLE</option>
                  <option value='TOURIST PERMIT'>TOURIST PERMIT</option>
                  <option value='TEMPORARY PERMIT'>TEMPORARY PERMIT</option>
                  <option value='NATIONAL PERMIT'>NATIONAL PERMIT</option>
                </select>
              </div>
              <div className='form__control'>
                <label className='form__label d-block w-100 text-left' htmlFor='taxUptoDate'>
                  Tax Upto Date<sup>*</sup>
                </label>
                <input
                  required
                  disabled={isLoading}
                  className='form__input w-100'
                  id='taxUptoDate'
                  name='taxUptoDate'
                  type='datetime-local'
                  value={payLoad.taxUptoDate}
                  onChange={onChangeHandler}
                />
              </div>
            </div>
          </div>

          {/* =============== table ======================== */}
          <div className='row mt-2'>
            <div className='col-12'>
              <table className='hr-table'>
                <thead>
                  <tr>
                    <th className='hr-table-1'>S. No.</th>
                    <th className='hr-table-2'>Tax/Fee Particulars</th>
                    <th>Tax From</th>
                    <th>Tax Upto</th>
                    <th>₹ Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className='hr-table-body'>1</td>
                    <td className='hr-table-body'>MV Tax</td>
                    <td className='hr-table-body'>
                      {payLoad.taxFromDate ? payLoad.taxFromDate.split('T')[0] : ''}
                    </td>
                    <td className='hr-table-body'>
                      {payLoad.taxUptoDate ? payLoad.taxUptoDate.split('T')[0] : ''}
                    </td>
                    <td className='hr-table-body'>
                      <input
                        type='number'
                        className='form__input'
                        name='mvTax'
                        value={payLoad.mvTax}
                        onChange={onChangeHandler}
                        required
                        min='0'
                        inputMode='numeric'
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          
          <br />
          <div className='row'>
            <div className='col-sm-6'>
              {/* <!-- Total amount --> */}
              <div className='form__control'>
                <label
                  className='form__label d-block w-100 text-left'
                  htmlFor='totalAmount'
                >
                  Total amount<sup>*</sup>
                </label>
                <input
                  required
                  tabIndex='22'
                  min='0'
                  disabled={isLoading}
                  value={payLoad.totalAmount}
                  onChange={onChangeHandler}
                  className='form__input w-100'
                  type='number'
                  id='totalAmount'
                  name='totalAmount'
                />
              </div>
            </div>
            <div className='col-sm-6'>
              <label className='form__label d-block w-100 text-left'>
                &nbsp;
              </label>
              <ActionButtons
                tabIndex='23'
                isDisabled={isLoading}
                onReset={onResetHandler}
              />
            </div>
          </div>
        </form>
        <br />
      </div>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
    </>
  );
};

export default Bihar;
